import { OperationalMascotController } from "./chat.mascot";
import "./fab.css";

export interface QuetzalitoFabActions {
  openChat: () => void;
  newConversation: () => void;
  showHistory: () => void;
}

export class QuetzalitoFab {
  private readonly wrap: HTMLElement;
  private readonly button: HTMLButtonElement;
  private readonly mascot: OperationalMascotController;

  constructor(actions: QuetzalitoFabActions) {
    this.wrap = document.createElement("div");
    this.wrap.className = "qp-quetzalito-fab-wrap";
    this.wrap.id = "quetzalito-fab-wrap";
    this.button = document.createElement("button");
    this.button.type = "button";
    this.button.className = "qp-quetzalito-fab";
    this.button.setAttribute("aria-label", "Abrir chat con Quetzalito");
    this.button.dataset.fabAction = "open";
    this.wrap.appendChild(this.button);
    this.wrap.insertAdjacentHTML("afterbegin", `<div class="qp-quetzalito-fab-actions" role="group" aria-label="Accesos rápidos de Quetzalito">
      <button type="button" class="qp-quetzalito-fab-action" data-fab-action="new" aria-label="Iniciar nueva conversación">
        <span class="qp-quetzalito-fab-action__label">Nuevo chat</span><i class="ph-bold ph-plus" aria-hidden="true"></i>
      </button>
      <button type="button" class="qp-quetzalito-fab-action" data-fab-action="history" aria-label="Ver historial de conversaciones">
        <span class="qp-quetzalito-fab-action__label">Historial</span><i class="ph-bold ph-clock-counter-clockwise" aria-hidden="true"></i>
      </button>
    </div>`);
    document.body.appendChild(this.wrap);

    this.mascot = new OperationalMascotController(this.button, () => false);
    this.render();
    this.wrap.addEventListener("pointerleave", () => this.wrap.classList.remove("is-actions-dismissed"));
    this.wrap.addEventListener("click", (event) => {
      const target = (event.target as HTMLElement).closest<HTMLButtonElement>("[data-fab-action]");
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      this.dismissActions();
      const action = target.dataset.fabAction;
      if (action === "new") actions.newConversation();
      else if (action === "history") actions.showHistory();
      else actions.openChat();
    });
  }

  private render(): void {
    this.button.innerHTML = `<span class="qp-quetzalito-fab__head">${this.mascot.render("header")}</span>`;
  }

  private dismissActions(): void {
    this.wrap.classList.add("is-actions-dismissed");
    this.wrap.querySelectorAll<HTMLButtonElement>("button").forEach((button) => button.blur());
  }

  hide(): void { this.wrap.classList.add("is-panel-open"); }

  show(): void {
    this.wrap.classList.remove("is-panel-open");
    if (!this.wrap.matches(":hover")) this.wrap.classList.remove("is-actions-dismissed");
  }
}
